import React, { useState, useEffect, useRef } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import './Pdf.css';

pdfjs.GlobalWorkerOptions.workerSrc = 'pdf.worker.min.js';
export default function Pdf(props) {
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const [pdfContainerWidth, setPdfContainerWidth] = useState(null);

    const pdfContainer = useRef(null);

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    function changePage(offset) {
        setPageNumber(prevPageNumber => prevPageNumber + offset);
    }

    function previousPage() {
        changePage(-1);
    }

    function nextPage() {
        changePage(1);
    }

    const setPdfSize = () => {
        setPdfContainerWidth(pdfContainer.current.getBoundingClientRect().width);
    };

    useEffect(() => {
        //   effect
        window.addEventListener('resize', setPdfSize);
        setPdfSize();
        return () => {
            //   cleanup
            window.removeEventListener('resize', setPdfSize);
        }
    }, [])


    return (
        <div className="pdf-container" ref={pdfContainer}>
            <Document
                file={props.src}
                onLoadSuccess={onDocumentLoadSuccess}
            >
                <Page pageNumber={pageNumber} width={pdfContainerWidth} />
            </Document>

            <div style={{ textAlign: 'center' }}>
                <p>
                    Página {pageNumber || (numPages ? 1 : "--")} de {numPages || "--"}
                </p>
                <button type="button" disabled={pageNumber <= 1} onClick={previousPage}>
                    Anterior
                </button>
                <button
                    type="button"
                    disabled={pageNumber >= numPages}
                    onClick={nextPage}
                >
                    Siguiente
                </button>
            </div>

            {/* <iframe src="./assets/files/ciclones/resumen-temporada/2021.pdf" frameborder="0" width="100%" height="960" /> */}
        </div>
    );
}